import React, { useEffect, useState } from 'react';
import { HolographicButton } from './HolographicButton';
import { ShieldCheck } from 'lucide-react';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const trackAddToCart = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Kit de Supervivencia: Ventas por DM',
        currency: 'COP',
        value: 29999
      });
    }
  };
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200 p-4 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] md:hidden animate-fade-in-up" data-id="element-27">
      <div className="max-w-md mx-auto flex flex-col gap-2" data-id="element-28">
        <HolographicButton variant="success" size="md" fullWidth href="https://krove.lat//cart/40650717790337:1" id="buyNowSticky" onClick={trackAddToCart} data-id="element-29">
          Comprar $29.999
        </HolographicButton>
        <div className="flex items-center justify-center text-xs text-gray-500 gap-1" data-id="element-30">
          <ShieldCheck className="w-3 h-3 text-success" data-id="element-31" />
          <span data-id="element-32">Garantía 7 días • Pago seguro</span>
        </div>
      </div>
    </div>;
}